#define M_PI 3.1415926535897932384626433832795

uniform vec3 uColor;
uniform vec3 uAccentColor;
uniform float uAlpha;
uniform float uLoadProgress;
uniform float uProgress;
uniform float uRadius;
uniform float uBorderWidth;
uniform float uTime;

varying vec3 vPosition;

void main()
{
    float dist = length(vPosition.xy);
    float normalized = clamp(dist / max(uRadius, 0.0001), 0.0, 1.0);

    float rimStart = max(0.0, 1.0 - uBorderWidth / max(uRadius, 0.0001));
    float rim = smoothstep(rimStart, 1.0, normalized) - smoothstep(1.0, 1.0 + (uBorderWidth / max(uRadius, 0.0001)), normalized);
    float fill = smoothstep(0.0, 0.8, normalized) * (1.0 - normalized);
    float pulse = 0.5 + 0.5 * sin(uTime * 0.002 + normalized * 10.0);

    float loadMask = step(abs(normalized - 0.5), clamp(uLoadProgress * 0.5, 0.0, 0.5));
    float fade = clamp(uProgress, 0.0, 1.0);

    float alpha = (rim * 0.7 + fill * 0.3) * uAlpha * pulse * loadMask * fade;
    if(alpha <= 0.0)
    {
        discard;
    }

    vec3 color = mix(uColor, uAccentColor, pulse);
    gl_FragColor = vec4(color, alpha);
}
